import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import '../styles/UpdatesBox.css';

const UpdatesBox = () => {
  const { t } = useTranslation();
  const [updates, setUpdates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadUpdates();
  }, []);

  const loadUpdates = async () => {
    try {
      setLoading(true);
      const response = await axios.get('http://localhost:5000/api/updates');
      setUpdates(response.data.slice(0, 5)); // Show last 5 updates
    } catch (error) {
      console.error('Error loading updates:', error);
    } finally {
      setLoading(false);
    }
  };

  const getPriorityColor = (priority) => {
    const colors = {
      low: '#888',
      medium: '#1dd1a1',
      high: '#ffd93d',
      critical: '#ff6b6b',
    };
    return colors[priority] || '#888';
  };

  const formatDate = (date) => {
    const now = new Date();
    const diff = now - new Date(date);
    const days = Math.floor(diff / 86400000);
    const hours = Math.floor(diff / 3600000);
    const minutes = Math.floor(diff / 60000);

    if (minutes < 60) return `${minutes}m ago`;
    if (hours < 24) return `${hours}h ago`;
    if (days < 7) return `${days}d ago`;
    return new Date(date).toLocaleDateString();
  };

  if (loading) {
    return <div className="updates-box">{t('common.loading')}...</div>;
  }

  if (updates.length === 0) {
    return (
      <div className="updates-box">
        <h3 style={{ color: '#1dd1a1', marginBottom: '1rem' }}>📢 Updates</h3>
        <div style={{ color: '#888', textAlign: 'center', padding: '1rem' }}>
          No updates yet
        </div>
      </div>
    );
  }

  return (
    <div className="updates-box">
      <h3 style={{ color: '#1dd1a1', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        📢 Updates
      </h3>
      <div className="updates-list">
        {updates.map((update) => (
          <div
            key={update._id}
            className="update-item"
            style={{
              borderLeft: `3px solid ${getPriorityColor(update.priority)}`,
            }}
          >
            <div className="update-header">
              <h4 style={{ color: '#fff', margin: '0 0 0.5rem 0' }}>{update.title}</h4>
              <span className="update-version" style={{ color: getPriorityColor(update.priority) }}>
                {update.version}
              </span>
            </div>

            {update.image && (
              <img
                src={`http://localhost:5000${update.image}`}
                alt={update.title}
                className="update-image"
              />
            )}

            <p
              className="update-content"
              style={{ color: 'rgba(255, 255, 255, 0.8)', fontSize: '0.9rem', margin: '0.5rem 0' }}
            >
              {update.content.substring(0, 100)}
              {update.content.length > 100 ? '...' : ''}
            </p>

            <div className="update-footer">
              <span style={{ color: '#888', fontSize: '0.85rem' }}>
                {update.author?.firstName} {update.author?.lastName}
              </span>
              <span style={{ color: '#888', fontSize: '0.85rem' }}>
                {formatDate(update.createdAt)}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UpdatesBox;
